import type { HandleClientError } from '@sveltejs/kit';
import * as Sentry from '@sentry/sveltekit';

type SentryEnvironment = 'production' | 'staging' | 'test' | 'e2e';

export interface SentryHandlers {
  handleError: HandleClientError;
}

export const createErrorHandler = (): SentryHandlers => {
  const environment = getEnvironment();

  if (environment === undefined) {
    return { handleError: logError };
  }

  Sentry.init({
    environment,

    dsn: 'https://e31f67b86b944ab0b16cbc4094cda195@o1356192.ingest.us.sentry.io/6641464',

    // TODO(mc, 2024-07-08): tune once we've collected some data
    tracesSampleRate: 1,

    // TODO(mc, 2024-07-08): tune once we've collected some data
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });

  return { handleError: Sentry.handleErrorWithSentry(logError) };
};

const getEnvironment = (): SentryEnvironment | undefined => {
  const { hostname } = window.location;

  if (hostname === 'app.viam.com') {
    return 'production';
  }

  if (hostname === 'app.viam.dev') {
    return 'staging';
  }

  if (hostname.endsWith('run.app')) {
    return 'test';
  }

  return undefined;
};

const logError: HandleClientError = ({ error, event }) => {
  // eslint-disable-next-line no-console
  console.error('An unhandled error occurred', error, event);
};
